export enum PartnerRegion {
  AF = 'AF',
  AP = 'AP',
  EMEA = 'EMEA',
  NA = 'NA',
  LA = 'LA',
  UNKNOWN = 'UNKNOWN',
}
